import { useEffect, useMemo, useRef } from 'react';
import { Picker } from 'emoji-mart';

import { DEFAULT_SETTINGS } from './emojiPicker.consts';
import { overwriteStyles, PickerWrapper } from './emojiPicker.styles';

type PickerOption = {
  native: string;
};
type Props = {
  onSelect: (emoji: PickerOption) => void;
};

export const EmojiPicker = ({ onSelect }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const instance = useRef(null);

  const settings = useMemo(
    () => ({
      ...DEFAULT_SETTINGS,
      onEmojiSelect: onSelect,
    }),
    [onSelect]
  );

  useEffect(() => {
    // @INFO typings are broken, `new Picker` does not respect `ref`
    // eslint-disable-next-line
    // @ts-ignore
    instance.current = new Picker({ ...settings, ref });
    instance.current.shadowRoot.appendChild(overwriteStyles);

    return () => {
      instance.current = null;
    };
    // @FIXME text editor does not memoize various callbacks (including onSelect),
    // causing picker to re-render and be broken when used along with the text editor
    // eslint-disable-next-line
  }, []);

  return <PickerWrapper ref={ref} />;
};
